import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  isLargeScreen,
  updateCustomTableHeaders,
} from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { AddEditClientComponent } from '../../../shared/components/add-edit-client/add-edit-client.component';
import { ConfirmDialogComponent } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ModalDialogueService } from '../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { ClientsService } from './clients.service';
@Component({
  selector: 'gtapp-clients',
  templateUrl: './clients.component.html',
  styleUrl: './clients.component.scss',
  standalone: false,
})
export class ClientsComponent implements OnInit, OnDestroy {
  clientSearchString: string = '';
  previousClients: number = 0;
  rowsClients: number = 10;
  pageNumClients: number = 1;
  totalPagesClients: number = 0;
  sortKeyClients: any;
  searchParamsClients: any;

  clientPaginationData: any = {};

  clientDetailsTableView: any = [];

  clientDropDownList: any = [];
  totalClientCount: number = 0;

  otherParamsClients: any = {
    apiFiltering: true,
  };

  largeView: Boolean = isLargeScreen;

  tableStyle = {
    'overflow': 'auto',
    'max-height': '75vh',
  };

  userData: any;

  archivedCount: any;
  showArchivedList: boolean = false;

  tabNames = {
    tab1: 'Sites',
    tab2: 'Clients',
    tab3: 'Site Keys',
    tab4: 'Sub Biller',
  };

  siteKeyExists: boolean = false;
  selectedTab = this.tabNames.tab1;

  constructor(
    private clientService: ClientsService,
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
    private dialogService: ModalDialogueService,
  ) {
    this.formatRouteUrl();
    this.getTableDetails();
  }

  ngOnInit(): void {
    this.userData = this.appService.getUserData();

    this.rowsClients = Number(
      this.userData?.preferences?.client_page_size || 10,
    );
    this.spinnerService.show();
    this.siteKeyExistsCheck();
    this.changeTab(this.selectedTab);
  }
  siteKeyExistsCheck() {
    let params: any = { exists_check: 1 };

    this.spinnerService.show();
    this.clientService.listSiteKeys(params).then((res: any) => {
      this.siteKeyExists = res?.data;
    });
  }
  ngOnDestroy(): void {
    // this.saveAuditDraft();
  }
  selectTabDropDown(event: any) {
    this.changeTab(event?.target?.value);
  }

  changeTab(tab: any) {
    this.router.navigate([], {
      replaceUrl: true, // Replaces the current URL without adding a new history entry
    });
    if (Object.values(this.tabNames)?.includes(tab)) {
      this.selectedTab = tab;

      if (this.selectedTab === this.tabNames.tab2) {
        this.getClientListData();
      } else {
        this.clearValues();
      }
    }
  }
  getClientsCount(reqParams: any) {
    let params: any = { get_count: 1, ...reqParams };

    this.clientService.fetchCustomerList(params).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.otherParamsClients = {
          ...this.otherParamsClients,
          paginationData: {
            totalRows: response?.total_size,
            previousRows: this.previousClients,
            rows: this.rowsClients,
            pageNum: this.pageNumClients,
            totalPages: this.totalPagesClients,
          },
        };

        this.archivedCount = response?.archived_count || 0;
        this.totalClientCount = response?.company_count || 0;
        if (!this.archivedCount && this.showArchivedList) {
          this.getArchivedUnarchivedList();
        }
      }
    });
  }
  getClientListData(getCount = true) {
    let params: any = {};
    if (this.rowsClients) {
      params['rows'] = this.rowsClients;
      let userData = this.appService.getUserData();
      if (userData?.preferences) {
        userData.preferences.client_page_size = this.rowsClients;
        this.appService.setUserData(userData);
      }
    }

    if (this.previousClients) {
      params['previous'] = this.previousClients;
    }
    if (this.clientSearchString) {
      params['search_str'] = this.clientSearchString;
    }

    if (this.searchParamsClients) {
      Object.entries(this.searchParamsClients).forEach(
        ([key, value]) => (params[key] = value),
      );
    }

    if (this.sortKeyClients) {
      params['sort_key'] = this.sortKeyClients;
    }
    if (this.showArchivedList) {
      params['is_inactive'] = 1;
    }

    if (this.clientPaginationData?.[this.pageNumClients]?.length) return;
    if (getCount) this.getClientsCount(params);

    this.spinnerService.show();
    this.clientService.fetchCustomerList(params).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.clientPaginationData[this.pageNumClients] = [...response?.data];
        this.updateRoutPath();

        this.spinnerService.hide();
      } else {
        this.spinnerService.hide();
      }
    });
  }
  onChangePaginationClient(data: any) {
    this.previousClients = data?.paginationData?.previousRows;
    this.pageNumClients = data?.paginationData?.pageNum;
    if (data?.paginationData?.rows != this.rowsClients) {
      this.clientPaginationData = {};
    }
    this.rowsClients = data?.paginationData?.rows;

    this.otherParamsClients.paginationData = {
      ...data?.paginationData,
    };
    this.getClientListData(false);
  }
  sortColumnClient(body: any) {
    this.sortKeyClients = body?.sortList || [];
    this.searchParamsClients = body?.searchParams || {};
    this.clientSearchString = '';
    this.clientPaginationData = {};
    this.getClientListData(false);
  }
  searchColumnClient(event: any) {
    this.searchParamsClients = event?.searchParams || {};
    this.clearValues();
    this.getClientListData();
  }
  clearValues() {
    this.previousClients = 0;
    this.pageNumClients = 1;
    this.clientSearchString = '';
    this.clientPaginationData = {};
  }

  onClientLookup(event: any) {
    if (event.target.value.length > 3) {
      let params: any = { search_str: event.target.value };
      if (this.showArchivedList) {
        params['is_inactive'] = 1;
      }
      this.clientService.fetchCustomerList(params).subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.clientDropDownList = res?.data;
        }
      });
    }
  }

  openAddClientForm() {
    const dialogueRef = this.dialogService.open(AddEditClientComponent);
    dialogueRef.afterClosed().subscribe((value: any) => {
      if (value !== false) {
        this.clearValues();
        this.spinnerService.show();
        setTimeout(() => {
          this.getClientListData();
        }, 200);
      }
    });
  }

  openCustomerView(customer: any) {
    if (this.showArchivedList) {
      this.archiveUnarchive(customer);
    } else {
      this.router.navigate(['/view-client', { cKey: String(customer.id) }]);
    }
  }

  getArchivedUnarchivedList() {
    this.showArchivedList = !this.showArchivedList;
    this.clearValues();

    this.spinnerService.show();
    this.getClientListData();
  }

  archiveUnarchive(client: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: `Restore  Client `,
        message: ``,
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        this.spinnerService.show();
        this.clientService
          .enableDisableCompanyById(client?.id)
          .then((response: any) => {
            this.spinnerService.hide();
            if (response?.status == 'success') {
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });
              this.router.navigate([
                '/view-client',
                { cKey: String(client.id) },
              ]);
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
          });
      }
    });
  }
  updateRoutPath() {
    this.router.navigate([], {
      fragment: btoa(
        JSON.stringify({
          searchParams: this.searchParamsClients,
          otherParams: this.otherParamsClients,
          clientSearchString: this.clientSearchString,
          selectedTab: this.selectedTab,
          showArchivedList: this.showArchivedList,
        }),
      ),
      queryParams: {},
      replaceUrl: true,
    });
  }
  formatRouteUrl() {
    if (!this.route.snapshot.fragment) return;
    try {
      const urlFragmentDetails = JSON.parse(atob(this.route.snapshot.fragment));
      if (urlFragmentDetails && Object.keys(urlFragmentDetails)?.length) {
        this.searchParamsClients = {
          ...this.searchParamsClients,
          ...(urlFragmentDetails?.searchParams || {}),
        };
        this.selectedTab =
          urlFragmentDetails?.selectedTab || this.tabNames.tab1;

        if (!Object.values(this.tabNames)?.includes(this.selectedTab)) {
          this.selectedTab = this.tabNames.tab1;
        }

        this.clientSearchString = urlFragmentDetails?.clientSearchString || '';
        this.showArchivedList = urlFragmentDetails?.showArchivedList || false;
        if (urlFragmentDetails?.otherParams?.paginationData) {
          this.previousClients =
            urlFragmentDetails?.otherParams?.paginationData?.previousRows ||
            this.previousClients;
          this.pageNumClients =
            urlFragmentDetails?.otherParams?.paginationData?.pageNum ||
            this.pageNumClients;
          this.rowsClients =
            urlFragmentDetails?.otherParams?.paginationData?.rows ||
            this.rowsClients;
        }
      }
    } catch (error) {}
  }
  getTableDetails() {
    let tableDetails = [
      {
        header: '',
        name: 'company_name',
        sortKey: 'company_name',
        // searchKey: 'company_name',
        sortOrder: 'asc',
        columnDataStyle: {
          'white-space': 'pre-line',
          'font-size': '18px',
        },

        tableColumnStyle: {
          'white-space': 'pre-line',
        },

        suffixNestedValue: (row: any) => {
          let suffixList = [''];

          if (row?.full_address) {
            suffixList.push(row?.full_address);
          }
          return suffixList?.join('\n');
        },
        suffixStyle: {
          'font-size': 'small',
        },
      },
    ];

    updateCustomTableHeaders(tableDetails, this.searchParamsClients);

    this.clientDetailsTableView = [...tableDetails];
  }
}
